import * as Fetch from "../../../Common/fetch";
import * as ActionTypes from "./actionTypes";
import * as Notifier from "../../../Common/Notifications/helper";
import { IFormData } from "../DataTypes/formTypes";
import { FormState, IStore, IStoreCustomFormGrid, LockStatus } from "../DataTypes/storeTypes";
import { ServerResponseAdapter } from "common.ui/Notifications/ServerResponseAdapter";

export function onFormSave(data: IFormData) {
    return (dispatch, getState: () => IStore): Promise<void> => {
        const state = getState();
        return saveForm(dispatch, state, data);
    };
}

function saveForm(dispatch, store: IStore, data: IFormData): Promise<any> {
    dispatch(updateComposition(data.composition));
    dispatch(setFormState(FormState.Saving));
    dispatch(setIsBusy(true));

    return Fetch.post<any>(store.initialSettings.saveFormUrl, data)
        .then(() => {
            dispatch(setFormState(FormState.Saved));
            dispatch(setIsBusy(false));
            dispatch(setStatus(data.status));
        })
        .catch((serverResponse) => {
            const errorNotificationBuilder = ServerResponseAdapter.createErrorNotificationBuilder(serverResponse);
            errorNotificationBuilder.prependMessage(
                "There was a problem saving this data. " +
                    "Please try again, but if this continues, " +
                    "please copy the data and save it elsewhere before leaving this page."
            );
            Notifier.warn(errorNotificationBuilder.getMessages());
            dispatch(setIsBusy(false));
        });
}

export function setFormStateIfChanged(state: FormState) {
    return (dispatch, getState) => {
        const store: IStore = getState();

        if (store.common.formState !== state) {
            dispatch(setFormState(state));
        }
    };
}

export function setSubmitRequested(value: boolean) {
    return { type: ActionTypes.Actions.SetSubmitRequested, parameter: value };
}

export function setIsBusy(value: boolean) {
    return { type: ActionTypes.Actions.SetIsBusy, parameter: value };
}

function setFormState(state: FormState) {
    return { type: ActionTypes.Actions.SetFormState, parameter: state };
}

function setStatus(status: LockStatus) {
    return { type: ActionTypes.Actions.SetStatus, parameter: status };
}

function updateComposition(composition: any) {
    return { type: ActionTypes.Actions.UpdateComposition, parameter: composition };
}

export function removeClientFile(fileId: number) {
    return (dispatch, getState: () => IStore) => {
        const state = getState();

        return Fetch.post<any>(state.initialSettings.removeClientFileUrl, { id: fileId });
    };
}

export function goHome() {
    return (dispatch, getState: () => IStoreCustomFormGrid) => {
        const state = getState();

        window.location.assign(state.initialSettings.homeUrl);
    };
}

export function goToFormsPage() {
    return (dispatch, getState: () => IStore) => {
        const state = getState();

        if (state.initialSettings.redirectToFormsPage) {
            setTimeout(() => {
                window.location.assign(state.initialSettings.formsPageUrl);
            }, 3000);
        }
    };
}
